import { LoadingStates } from '@pb/utils'

import appSelectors from 'App/duck/selectors'

import { MergedOffers } from '../types'
import { OffersProps } from './types'

const getRewardsState = (state): any => state.account.clubRewards || []
const getMyRewards = (state): any => getRewardsState(state).rewards || []
const getMyNonExpiredRewards = (state): MergedOffers[] => {
  const availableRewards = getMyRewards(state).filter((reward) => {
    const now = new Date()

    // @ts-expect-error ts-migrate(2363) FIXME: The right-hand side of an arithmetic operation mus... Remove this comment to see the full error message
    return !(reward.isOfferActive && reward.activeOfferExpiresAt - now < 0)
  })
  return availableRewards?.sort(function (a, b) {
    return b.isOfferActive - a.isOfferActive || a.activeOfferExpiresAt - b.activeOfferExpiresAt
  })
}
const getMyOffers = (state): [] => getRewardsState(state).offers || []
const getMyVouchers = (state): [] => getRewardsState(state).vouchers || []

const getRewardDetailsLoadingState = (state): any => getRewardsState(state).rewardDetailLoadingState
const getRewardDetail = (state): any => getRewardsState(state).rewardDetail || null
const getIsRewardDetailLoading = (state): any =>
  getRewardDetailsLoadingState(state) === LoadingStates.Loading
const getIsRewardDetailLoaded = (state): any =>
  getRewardDetailsLoadingState(state) === LoadingStates.LoadedSuccess
const getIsRewardDetailFailed = (state): any =>
  getRewardDetailsLoadingState(state) === LoadingStates.LoadedFail

const getRewardByOfferPropositionId = (state, offerPropositionId): any =>
  getMyRewards(state).find(
    (reward) => reward.offerPropositionId === parseInt(offerPropositionId, 10),
  )

const shouldBeShown = (state): any => appSelectors.getUserIsFullMember(state)
const getRewardssLoadingState = (state): any => getRewardsState(state).rewardsLoadingState
const getIsRewardsLoading = (state): any =>
  appSelectors.getShowLoaders(state) || getRewardssLoadingState(state) === LoadingStates.Loading
const getIsRewardsLoadingFailed = (state): any =>
  getRewardssLoadingState(state) === LoadingStates.LoadedFail
const wasRewardsResponseEmpty = (state): any => getRewardsState(state).wasRewardsResponseEmpty
const shouldFetchRewards = (state): any =>
  getRewardssLoadingState(state) === LoadingStates.NotLoaded

const getRedeemOfferLoadingState = (state): any => getRewardsState(state).redeemOfferLoadingState
const getIsRedeemOfferLoading = (state): any =>
  getRedeemOfferLoadingState(state) === LoadingStates.Loading
const getIsRedeemOfferFailed = (state): any =>
  getRedeemOfferLoadingState(state) === LoadingStates.LoadedFail
const getIsRedeemOfferSuccess = (state): any =>
  getRedeemOfferLoadingState(state) === LoadingStates.LoadedSuccess

const getAddOfferToBagLoadingState = (state): any =>
  getRewardsState(state).addOfferToBagLoadingState
const getIsAddOfferToBagLoading = (state): any =>
  getAddOfferToBagLoadingState(state) === LoadingStates.Loading
const getIsAddOfferToBagFailed = (state): any =>
  getAddOfferToBagLoadingState(state) === LoadingStates.LoadedFail
const getIsAddOfferToBagSuccess = (state): any =>
  getAddOfferToBagLoadingState(state) === LoadingStates.LoadedSuccess
const getAddOfferToBagError = (state): any => getRewardsState(state).addOfferToBagErrorMessage

const getPromotionCodeLoadingState = (state): any =>
  getRewardsState(state).promotionCodeLoadingState
const getPromotionCodeLoading = (state): any =>
  getPromotionCodeLoadingState(state) === LoadingStates.Loading
const getPromotionCodeFailed = (state): any =>
  getPromotionCodeLoadingState(state) === LoadingStates.LoadedFail
const getPromotionCodeSuccess = (state): any =>
  getPromotionCodeLoadingState(state) === LoadingStates.LoadedSuccess
const getPromotionCodeError = (state): any => getRewardsState(state).promotionCodeErrorMessage

const getPromotionCode = (state): any => getRewardsState(state).promotionCode

const getSelectedTab = (state: OffersProps): string => getRewardsState(state).selectedTab

export default {
  getMyRewards,
  shouldBeShown,
  getIsRewardsLoading,
  getIsRewardsLoadingFailed,
  wasRewardsResponseEmpty,
  shouldFetchRewards,
  getMyNonExpiredRewards,
  getRewardByOfferPropositionId,
  getRewardDetail,
  getIsRewardDetailLoading,
  getIsRewardDetailLoaded,
  getIsRewardDetailFailed,
  getIsRedeemOfferFailed,
  getIsRedeemOfferLoading,
  getIsRedeemOfferSuccess,
  getIsAddOfferToBagFailed,
  getIsAddOfferToBagLoading,
  getIsAddOfferToBagSuccess,
  getAddOfferToBagError,
  getPromotionCodeLoading,
  getPromotionCodeFailed,
  getPromotionCodeSuccess,
  getPromotionCodeError,
  getPromotionCode,
  getMyOffers,
  getMyVouchers,
  getSelectedTab,
}
